import { ADVISOR_NOTES_RECEIVED, ADVISOR_NOTE_CREATED, ADVISOR_NOTE_UPDATED, ADVISOR_NOTE_DELETED } from './types'
import { isEmpty } from 'globals/utils'
export default function notes(state = [], action = {}){ 
  switch (action.type) {
    case ADVISOR_NOTES_RECEIVED:
        return action.data
    case ADVISOR_NOTE_CREATED:
      if (isEmpty(state)) { state = []}
      state.push(action.data)
      return state
    case ADVISOR_NOTE_UPDATED:
      state = state.map((item, index) => {
        // Find the item with the matching id
        if(item.id === action.data.id) {
          return action.data 
        }
        return item 
      }) 
      return state
    case ADVISOR_NOTE_DELETED:
      return state.filter(n => n.id !== action.data) 
    default:
      return state;
  }
}
